/**
 * SINGLE SOURCE for the company details the public site prints.
 *
 * Confirmed by the owner 2026-09-15: legal name, registered office, company
 * number and ICO registration. The email stays on the old domain until a
 * mailbox exists on the live one (python_functions/main.py also hard-codes
 * it in a waitlist reply).
 */
export const COMPANY = {
  legalName: 'Melio Health Solutions Ltd',
  tradingName: 'Melio',
  descriptor: 'Health management',
  siteUrl: 'https://meliohealthmgmt.co.uk',
  email: 'hello@meliotherapeutics.uk',
  phone: '+447401062063',
  phoneDisplay: '+44 7401 062063',
  city: 'London',
  registeredIn: 'England and Wales',
  companyNumber: '16497996' as string | null,
  /** Information Commissioner's Office registration. */
  icoRegistration: 'ZC153092',
  /** Registered office, one line per entry, printed under the legal name. */
  registeredOffice: ['5th Floor', '167–169 Great Portland Street', 'London W1W 5PF', 'United Kingdom'],
} as const;
